import { SETTINGS_TOUR_STEPS } from "./steps/settings-tour.steps";
import { resolveTourStepsForRole } from "./resolveTourStepsForRole";

export function resolveSettingsTourSteps(role, { canAccessRoleSettings = false } = {}) {
  return resolveTourStepsForRole(SETTINGS_TOUR_STEPS, role, {
    canAccessRoleSettings,
  });
}
